export const ProgramsSlideBtnArrowIcon = (): JSX.Element => (
  <div className="inline-block relative before:absolute before:top-0 before:left-0 before:mt-[-4px] lg:mt-[1.5vw] ml-[.6vw] w-full before:w-[.8vw] h-full before:h-[.8vw] before:border-t-2 before:border-r-2 before:border-white before:rotate-[45deg]" />
)
